// HANDSOME HEADWEAR — Cart Rewards Bar
// Envío grátis con $500+ en el carrito
// 3+ sombreros (product_type "Sombreros") → Gorra grátis

(function () {
  'use strict';

  const CAP_VARIANT_ID = 45819543191688;
  const HAT_PRODUCT_TYPE = 'Sombreros';
  const MAX_HATS = 3;
  const FREE_SHIPPING_THRESHOLD = 500; // en MXN

  var _syncingGifts = false;
  var _syncTimer = null;
  var _barTimer = null;

  // ─── CARRITO ──────────────────────────────────────────────

  function countHats(cart) {
    var total = 0;
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      if (item.product_type === HAT_PRODUCT_TYPE && item.variant_id !== CAP_VARIANT_ID) {
        total += item.quantity;
      }
    }
    return total;
  }

  function getCapLines(cart) {
    var lines = [];
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].variant_id === CAP_VARIANT_ID) {
        lines.push({ line: i + 1, key: cart.items[i].key });
      }
    }
    return lines;
  }

  // cart.total_price viene en centavos
  function getTotalMXN(cart) {
    return cart.total_price / 100;
  }

  // ─── SINCRONIZACIÓN DE GORRA ──────────────────────────────

  function scheduleSyncGifts() {
    if (_syncTimer) clearTimeout(_syncTimer);
    _syncTimer = setTimeout(syncGifts, 1000);
  }

  function syncGifts() {
    if (_syncingGifts) return;
    _syncingGifts = true;

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var hats = countHats(cart);
        var total = getTotalMXN(cart);
        var capLines = getCapLines(cart);
        var hasCap = capLines.length > 0;
        var shouldHaveCap = hats >= MAX_HATS;

        updateRewardsBar(hats, total);

        // Limpiar duplicados
        if (capLines.length > 1) {
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ line: capLines[capLines.length - 1].line, quantity: 0 })
          }).then(function () {
            _syncingGifts = false;
            setTimeout(syncGifts, 600);
          }).catch(function () { _syncingGifts = false; });
          return;
        }

        if (shouldHaveCap && !hasCap) {
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: CAP_VARIANT_ID, quantity: 1, properties: { _regalo: 'gorra' } })
          }).then(function () {
            _syncingGifts = false;
          }).catch(function () { _syncingGifts = false; });
          return;
        }

        if (!shouldHaveCap && hasCap) {
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ line: capLines[0].line, quantity: 0 })
          }).then(function () {
            _syncingGifts = false;
            setTimeout(updateBarFromCart, 400);
          }).catch(function () { _syncingGifts = false; });
          return;
        }

        _syncingGifts = false;
      })
      .catch(function () { _syncingGifts = false; });
  }

  // ─── BARRA VISUAL ─────────────────────────────────────────

  function updateBarFromCart() {
    if (_barTimer) clearTimeout(_barTimer);
    _barTimer = setTimeout(function () {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          updateRewardsBar(countHats(cart), getTotalMXN(cart));
        })
        .catch(function () {});
    }, 300);
  }

  // ── Envío grátis ──
  function updateShippingBar(total) {
    var wrap = document.getElementById('crb-shipping');
    var fill = document.getElementById('crb-shipping-fill');
    var track = document.getElementById('crb-shipping-track');
    var msg = document.getElementById('crb-shipping-message');
    if (!wrap) return;

    var pct = Math.min((total / FREE_SHIPPING_THRESHOLD) * 100, 100);
    var unlocked = total >= FREE_SHIPPING_THRESHOLD;

    if (fill) fill.style.width = pct + '%';
    if (track) track.setAttribute('aria-valuenow', total);

    wrap.classList.toggle('unlocked', unlocked);

    if (msg) {
      if (unlocked) {
        msg.textContent = '¡Envío grátis desbloqueado!';
      } else {
        var remaining = FREE_SHIPPING_THRESHOLD - total;
        msg.textContent = 'Agrega $' + remaining.toFixed(2) + ' más para envío grátis';
      }
    }
  }

  // ── Recompensa de gorra ──
  function getMessage(qty) {
    if (qty === 0) return 'Agrega 3 sombreros para desbloquear';
    if (qty === 1) return '2 sombreros más para gorra grátis';
    if (qty === 2) return '¡1 sombrero más y llevas gorra grátis!';
    return '🧢 ¡Gorra grátis desbloqueada!';
  }

  function updateRewardsBar(qty, total) {
    var bar = document.getElementById('cart-rewards-bar');
    if (!bar) return;

    updateShippingBar(total);

    var pct = Math.min((qty / MAX_HATS) * 100, 100);
    var fill = document.getElementById('crb-fill');
    var track = document.getElementById('crb-track');
    if (fill)  fill.style.width = pct + '%';
    if (track) track.setAttribute('aria-valuenow', qty);

    var msg = document.getElementById('crb-message');
    if (msg) {
      msg.textContent = getMessage(qty);
      msg.classList.toggle('active', qty >= MAX_HATS);
    }

    var dot = document.getElementById('crb-dot-3');
    if (dot) dot.classList.toggle('reached', qty >= MAX_HATS);

    var tier = document.getElementById('crb-tier-3');
    if (tier) tier.classList.toggle('unlocked', qty >= MAX_HATS);

    var badge = document.getElementById('crb-badge-3');
    if (badge) {
      if (qty >= MAX_HATS) {
        badge.textContent = '¡Grátis!';
        badge.className = 'crb-tier-badge unlocked';
      } else {
        var diff = MAX_HATS - qty;
        badge.textContent = diff === 1 ? '1 falta' : diff + ' faltan';
        badge.className = 'crb-tier-badge';
      }
    }
  }

  // ─── OBSERVER Y EVENTOS ───────────────────────────────────

  var _drawerPresent = false;
  new MutationObserver(function () {
    var nowPresent = !!document.getElementById('cart-rewards-bar');
    if (nowPresent && !_drawerPresent) {
      updateBarFromCart();
      scheduleSyncGifts();
    }
    _drawerPresent = nowPresent;
  }).observe(document.body, { childList: true, subtree: true });

  ['cart:updated', 'cart:refresh', 'cart:item-added', 'cart:item-removed', 'theme:cart:open']
    .forEach(function (ev) {
      document.addEventListener(ev, function () {
        updateBarFromCart();
        scheduleSyncGifts();
      });
    });

  var _fetch = window.fetch;
  window.fetch = function () {
    var args = Array.prototype.slice.call(arguments);
    var url  = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
    var promise = _fetch.apply(this, args);
    if (/\/cart\/(add|change|update)/.test(url) && !_syncingGifts) {
      promise.then(function () {
        updateBarFromCart();
        scheduleSyncGifts();
      });
    }
    return promise;
  };

  var _xhrOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this._crbUrl = url;
    return _xhrOpen.apply(this, arguments);
  };
  var _xhrSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    if (this._crbUrl && /\/cart\/(add|change|update)/.test(this._crbUrl) && !_syncingGifts) {
      this.addEventListener('load', function () {
        updateBarFromCart();
        scheduleSyncGifts();
      });
    }
    return _xhrSend.apply(this, arguments);
  };

  updateBarFromCart();

})();